import { render, staticRenderFns } from "./RateFraudFreeContent.vue?vue&type=template&id=6fabfd1f&scoped=true&"
import script from "./RateFraudFreeContent.vue?vue&type=script&lang=ts&setup=true&"
export * from "./RateFraudFreeContent.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./RateFraudFreeContent.vue?vue&type=style&index=0&id=6fabfd1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fabfd1f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fabfd1f')) {
      api.createRecord('6fabfd1f', component.options)
    } else {
      api.reload('6fabfd1f', component.options)
    }
    module.hot.accept("./RateFraudFreeContent.vue?vue&type=template&id=6fabfd1f&scoped=true&", function () {
      api.rerender('6fabfd1f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/info/rate-fraud-free/index/RateFraudFreeContent/RateFraudFreeContent.vue"
export default component.exports